'use strict';

var constant = { "salscale": 0.035, "int": 0.072, "ctbrate": 0.06 };
var vint = (1 + constant.salscale) / (1 + constant.int);
var suggRetAge = 0;
var custAgeMinBound = 0;
var custAgeMaxBound = 0;
var combinedlost = 0;

var ER =  [ [ { "target_sugg_age": 65, "min_svc_yr": 30, "min_ret_age": 58, "min_proj_yr": 3, "nra": 65, "max_custom_age": 70, "formula": 0.015 },
    { "target_sugg_age": 62, "min_svc_yr": 30, "min_ret_age": 0, "min_proj_yr": 3, "nra": 58, "max_custom_age": 70, "formula": 0.0167 },
    { "target_sugg_age": 62, "min_svc_yr": 30, "min_ret_age": 0, "min_proj_yr": 3, "nra": 60, "max_custom_age": 70, "formula": 0.0167 }
],
    [ { "target_sugg_age": 60, "min_svc_yr": 25, "min_ret_age": 53, "min_proj_yr": 3, "nra": 60, "max_custom_age": 70, "formula": 0.018 },
        { "target_sugg_age": 55, "min_svc_yr": 25, "min_ret_age": 50, "min_proj_yr": 3, "nra": 55, "max_custom_age": 70, "formula": 0.02 },
        { "target_sugg_age": 55, "min_svc_yr": 25, "min_ret_age": 50, "min_proj_yr": 3, "nra": 55, "max_custom_age": 70, "formula": 0.02 }
    ] ];

var TT = [ { 10: 1.01, 20: 1.02, 25: 1.03, 30: 1.04 }, { 10: 1.01, 20: 1.025, 25: 1.04 } ]

function calcComp(cursal, futsvcx, cap, years) {
    if (years === 0) {
        return 0;
    }
    else {
        years = years - 1;
        var comp = Math.round(cursal * Math.pow((1 + constant.salscale), futsvcx - years), 0);
        comp = (cap > 0) ? Math.min(comp, cap):comp;
        return comp + calcComp(cursal, futsvcx, cap, years);
    }
}
function calcLostCalc(retage, age, cursal, iapbal, svc) {
    var program = jQuery('input[name="program"]:checked').val();
    var policefire = jQuery('input[name="policefire"]:checked').val();
    var futsvcx = retage - age;
    var projsvcx = svc + futsvcx;
    var projiap = Math.round(iapbal * Math.pow((1 + constant.int),futsvcx), 0) + Math.round(cursal * constant.ctbrate * (1 - Math.pow(vint, futsvcx)) * Math.pow((1 + constant.int), futsvcx)/(1 - vint), 0);
    var projiapsb560 = Math.round(iapbal * Math.pow((1 + constant.int), 2), 0) + Math.round(cursal * constant.ctbrate * (1 - Math.pow(vint, 2)) * Math.pow((1 + constant.int), 2)/(1 - vint), 0);
    projiapsb560 = Math.round(projiapsb560 * Math.pow(1 + constant.int, futsvcx - 2), 0);
    var projiapbuehler = Math.round(iapbal * (1 +  constant.int), 0) + Math.round( cursal * constant.ctbrate * (1 - vint) * (1 + constant.int)/(1 - vint), 0);
    projiapbuehler = Math.round(projiapbuehler * Math.pow((1 + constant.int), (futsvcx - 1)), 0);

    //IAP Lost
    var lost = Math.round( 100 * (projiap - projiapbuehler) / projiap, 0);

    var avgcomp = Math.round( calcComp(cursal, futsvcx, 0, 3)/3, 0 );
    var formula = ER[policefire][program].formula;
    var taxadj = 1;
    for (var key in TT[policefire]) {
        if (projsvcx >= key) taxadj = TT[policefire][key];
    }
    var iapassalfactor = ((program == 0) ? 1: 1.06) / 12;
    var projmb =  Math.round( Math.round( calcComp(cursal, futsvcx, 0, 3)/3, 0 ) * formula * taxadj * projsvcx * iapassalfactor, 0 );
    console.log ( "ProjMB: " + projmb);
    var projmbbuehler =  Math.round( Math.round( calcComp(cursal, futsvcx, 100000, 3)/3, 0 ) * formula * taxadj * projsvcx * 1/12, 0 );

    //Benefit Lost
    var benlost = Math.round( 100 * (projmb - projmbbuehler) / projmb, 0);

    combinedlost = Math.round( (( 100 * (projiap - projiapbuehler) / projiap ) * 0.308) + (( 100 * (projmb - projmbbuehler) / projmb ) * 0.692) );

    // jQuery("#result_text__top").html("If you retire at "+retage+", your benefits will be");
    jQuery("#result_text__top").html("your retirement would be cut");
    jQuery("#result_lost").html(combinedlost+'%');
    jQuery("#result_text").html(" by Knute buehler.");
    // jQuery("#result_text").html("less under Knute Buehler's retirement reduction plan.");
}
function triggerLostCalc() {
    var retage = (jQuery('input[name="ret_age"]').val())?jQuery('input[name="ret_age"]').val():suggRetAge;
    var age = jQuery('input[name="age"]').val();
    var svc = jQuery('input[name="serviceyr"]').val();
    var cursal = jQuery('input[name="cursal"]').val();
    var iapbal = jQuery('input[name="iapbal"]').val();
    if (retage && age && cursal && iapbal && svc) {
        calcLostCalc(parseInt(retage), parseInt(age), parseInt(cursal), parseInt(iapbal), parseInt(svc));
    }
}
function calcSuggRetAge(age, serviceyr, program, policefire, cretage) {
    var calcBase = ER[policefire][program];
    var minRetAge = Math.max(age + calcBase.min_svc_yr - serviceyr, calcBase.min_ret_age);
    custAgeMinBound = Math.max(Math.min(minRetAge, calcBase.nra), age + calcBase.min_proj_yr);
    custAgeMaxBound = Math.max(calcBase.max_custom_age, age + calcBase.min_proj_yr);
    suggRetAge = Math.max(Math.min(minRetAge, calcBase.target_sugg_age), age + calcBase.min_proj_yr );
//    console.log("Suggeted age: " + Math.max(Math.min(minRetAge, calcBase.target_sugg_age))  + " OR " + age + calcBase.min_proj_yr + " = " + suggRetAge);

    var top_message = '';

    if (cretage) {
        //Check if custom age is out of bound
        if (cretage < suggRetAge || cretage > custAgeMaxBound ) {
            var sbj_program_text = ["OPSRP","Tier 1", "Tier 2"];
            jQuery('input[name="ret_age"]').val('');
            top_message = '<span class="icon-error"></span> If you are ' + sbj_program_text[program];
            top_message += (policefire)?" Police & Fire":"";
            top_message += ", your planned retirement age must be at least " + calcBase.nra;
            top_message += (!policefire && (program === 1 || program === 2))?", or any age":", or age "+calcBase.min_ret_age;
            top_message += " with at least " + calcBase.min_svc_yr + " years of service.";
            jQuery('#custom-age-message').css({color: '#730303'});
        }
        //If not out of bound, all good, reset error message
        else {
            jQuery('#custom-age-message').css({color: '#333'});
        }
    }

    jQuery('#suggest-number').html(suggRetAge);
    jQuery('#custom-age-message__top').html('<span></span><b>'+top_message+'</b></span>');
    jQuery('#custom-age-message').html('<span>Must be at least 1 year older than your current age.</span><span>Your planned retirement age can be up to age ' + custAgeMaxBound + '. If you are over 70, it can be up to three years past your current age.</span>');
    //jQuery('#custom-age-message').html('Your planned retirement age must be at least '+custAgeMinBound+' and can be up to age ' + custAgeMaxBound + '.');
    //triggerLostCalc();
}
function triggerSuggRetAge() {
    var age = parseFloat(jQuery('input[name="age"]').val());
    var serviceyr = parseFloat(jQuery('input[name="serviceyr"]').val());
    var program = jQuery('input[name="program"]:checked').val();
    var policefire = jQuery('input[name="policefire"]:checked').val();
    var cretage = jQuery('input[name="ret_age"]').val();
    if (age && serviceyr && program && policefire && age > serviceyr) {
        jQuery('.hide-result').show();
        calcSuggRetAge(age, serviceyr, parseInt(program), parseInt(policefire), parseFloat(cretage));
    }
    else {
        jQuery('#suggest-number').html('--');
        jQuery('.hide-result').hide();

    }
    /*
     console.log("Age: " + jQuery('input[name="age"]').val());
     console.log("Years of Service: " + jQuery('input[name="serviceyr"]').val());
     console.log("Program: " + jQuery('select[name="program"]').val());
     console.log("Police/Fire? " + jQuery('input[name="policefire"]:checked').val())
     */
}
function hide_field() {
    jQuery('.calculator-field').css({opacity: '0.3'});
    jQuery('.calculator-disable').show();
    jQuery('#calculator-result').show();
    jQuery('#recalculate').show();
}

function show_field() {
    jQuery('.calculator-field').css({opacity: '1'});
    jQuery('.calculator-disable').hide();
    jQuery('#calculator-result').hide();
}

function enable_fixed(top) {
    jQuery('#calculator-result').css({
        top: top + 'px'
    });
}

function disabled_fixed() {
    jQuery('#calculator-result').css({
        top: '0'
    });
}

function clean_number_format(num) {
    num = '' + num;
    num = num.toString().replace(/[^0-9.]/g, "");
    var check = num.split('.');
    if(check.length > 1) {
        num = parseFloat(num);
        return num.toFixed(2);
    }
    return parseFloat(num);
}
function money_format(num) {
    num = clean_number_format(num);
    num = '' + num;
    num = '$'+num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    return num;
}

jQuery('#calculate_now').on('click', function(e) {
    e.preventDefault();
    hide_field();
    jQuery(this).hide();
    triggerLostCalc();
    // jQuery(document).scroll();
    jQuery('#contact-popup').modal('toggle');
    // jQuery('html, body').animate({
    //     'scrollTop': jQuery('#calculator-result').offset().top - 100,
    // }, 500);
});

jQuery('#recalculate').on('click', function (e) {
    e.preventDefault();
    triggerLostCalc();
    /*jQuery(document).scroll();*/
    jQuery('#contact-popup').modal('toggle');
});


jQuery('.transform_money').on('change', function(e) {
    var id = jQuery(this).attr('id');
    var val = jQuery(this).val();
    var money;
    money = money_format(val);
    id = id.toString().replace('_2', '');
    jQuery('#'+id).val(clean_number_format(val));
    jQuery(this).val(money);
    triggerSuggRetAge();
});

jQuery('#twitter_link').click(function(e) {
    e.preventDefault();
    var meta_tw_text = encodeURIComponent('The Buehler plan will cut my retirement by '+ combinedlost +'%. I kept my end of the deal. Oregon’s leaders should not break their promises to employees like me. #orpol #orleg #NoThanksKnute');
    var meta_tw_url = encodeURIComponent(option_object.siteurl+'/calculate/');
    var meta_height = 500;
    var meta_width = 500;
    var url  = 'https://twitter.com/intent/tweet?text=' + meta_tw_text + '&url=' + meta_tw_url;

    var twitterWindow = window.open(url, 'twitter-popup', 'height='+ meta_height +',width=' + meta_width);
    if(twitterWindow.focus){
        twitterWindow.focus();
    }

});

jQuery('#fb_link').click(function(e) {
    e.preventDefault();
    /*var meta_height = 500;
    var meta_width = 500;
    var meta_fb_text = encodeURIComponent('The Buehler plan will cut my retirement by '+ combinedlost +'%. I kept my end of the deal. Oregon’s leaders should not break their promises to employees like me.');
    var meta_fb_url = encodeURIComponent('https://keeporegonspromise.dev.s360.is/retirement-risk-calculator');

    var url  = 'https://www.facebook.com/sharer.php?t=' + meta_fb_text + '&u=' + meta_fb_url;

    var facebookWindow = window.open(url, 'facebook-popup', 'height='+ meta_height +',width=' + meta_width);
    if(facebookWindow.focus){
        facebookWindow.focus();
    }
    console.log(url);*/

    var meta_fb_text = 'The Buehler plan will cut my retirement by '+ combinedlost +'%. I kept my end of the deal. Oregon’s leaders should not break their promises to employees like me.';

    FB.ui({
        method: 'share',
        href: option_object.siteurl+'/calculate',
        quote: meta_fb_text,
    }, function(response){});
});

jQuery(".recalc_sugg_age").change(triggerSuggRetAge);
//jQuery(".recalc_lost").change(triggerLostCalc);

/*jQuery(document).on('scroll', function() {
    var display = jQuery('#calculator-result').css('display');
    var get_width = jQuery(window).width();
    if(get_width > 767) {
        if(display === 'block') {
            var height1 = parseInt(jQuery('#custom-header-outer').height());
            var height2 = parseInt(jQuery('#the_content').height());
            var height3 = 60;
            var height = height1 + height2 + height3;

            if(get_width < 992) {
                height = height + parseInt(jQuery('.navbar.sidebar').height());
            }

            if(jQuery(this).scrollTop() >= height){
                enable_fixed(jQuery(this).scrollTop() - height);
            }
            else {
                disabled_fixed();
            }
        }
        else {
            disabled_fixed();
        }
    }
    else {
        disabled_fixed();
    }
});*/

/*jQuery.validator.setDefaults({
 debug: true,
 success: "valid"
 });*/
jQuery.validator.addMethod("currency", function (value, element) {
    return this.optional(element) || /^\$(\d{1,3}(\,\d{3})*|(\d+))(\.\d{2})?$/.test(value);
}, "Please specify a valid amount");

jQuery( "#calculator" ).validate({
    rules: {
        age: {
            required: true,
            number: true
        },
        cursal_2: {
            required: true,
            currency: true
        },
        serviceyr: {
            required: true,
            number: true
        },
        iapbal_2: {
            required: true,
            currency: true
        },
        ret_age: {
            number: true
        }
    }
});
